'use strict';
export default class ProductsBlock {
    constructor(block) {
        this.productsItemsObject = {};
        this.activeFilter = 'all';
        this.productsListing = block.querySelector('.products-listing');
        this.filterNavItems = block.querySelectorAll('.product-categories-nav .categories-filter-btn');
        this.productsItems = block.querySelectorAll('.card-product');
        this.productsItemsObject = this.setProductObject();
        this.addCategoriesNavEvents();
    }
    addCategoriesNavEvents() {
        this.filterNavItems.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                this.productsListing.classList.add('fade-out');
                this.productsListing.classList.remove('fade-in');
                this.filterNavItems.forEach((navItem) => { navItem.classList.remove('is-active'); });
                this.activeFilter = item.getAttribute('data-slug');
                item.classList.add('is-active');
                this.updateVisibleItems();
            });
        });
    }
    updateVisibleItems() {
        setTimeout(() => {
            this.productsListing.classList.add('fade-in');
        }, 200);
        if (!this.productsItemsObject[this.activeFilter]) {
            this.productsItems.forEach((item) => {
                item.parentElement.classList.remove('d-none');
                item.parentElement.setAttribute('class', item.parentElement.getAttribute('data-grid-class'));
            });
            return;
        }
        this.productsItems.forEach((item) => { item.parentElement.classList.add('d-none'); });
        this.productsItemsObject[this.activeFilter].forEach((item) => {
            item.parentElement.classList.remove('d-none');
            item.parentElement.classList.replace('col-md-8', 'col-md-4');
            item.parentElement.classList.replace('col-md-6', 'col-md-4');
        });
    }
    getCategoriesList() {
        const items = {};
        this.filterNavItems.forEach((item) => {
            if (item.getAttribute('data-slug') === 'all')
                return;
            items[item.getAttribute('data-slug')] = [];
        });
        return items;
    }
    setProductObject() {
        const productsItemsObject = this.getCategoriesList();
        this.productsItems.forEach((item) => {
            const categories = item.getAttribute('data-category').split(',');
            categories.forEach((category) => {
                if (productsItemsObject[category]) {
                    productsItemsObject[category].push(item);
                }
            });
        });
        return productsItemsObject;
    }
}
const productsBlocks = document.querySelectorAll('.block.products');
productsBlocks.forEach((block) => new ProductsBlock(block));
